import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-external-link',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="external-link-container">
      <div class="redirect-content">
        <div class="loading-spinner" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <i class="fa fa-external-link" *ngIf="!isLoading"></i>
        <h4>{{ isLoading ? 'Weiterleitung wird vorbereitet...' : 'Neue Seite geöffnet' }}</h4>
        <p *ngIf="!isLoading">Die Seite wurde in einem neuen Tab geöffnet.</p>
        <p *ngIf="!isLoading"><a [href]="currentUrl" target="_blank">Hier klicken, falls sich kein neues Fenster öffnet</a></p>

        <button class="btn-back" (click)="goBack()" *ngIf="!isLoading">
          <i class="fa fa-arrow-left"></i> Zurück
        </button>
      </div>
    </div>
  `,
  styles: [`
    .external-link-container {
      display: flex;
      align-items: start;
      justify-content: center;
      margin-top: 3rem;
      height: 100vh;
      background: #f8f9fa;
    }

    .redirect-content {
      background: white;
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.1);
      text-align: center;
      max-width: 400px;
    }

    .spinner {
      border: 3px solid #f3f3f3;
      border-top: 3px solid #CC0F3C;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .redirect-content i.fa-external-link {
      font-size: 3rem;
      color: #CC0F3C;
      margin-bottom: 20px;
    }

    .redirect-content h4 {
      color: #333;
      margin-bottom: 15px;
      font-size: 1.4rem;
    }

    .redirect-content p {
      color: #666;
      margin-bottom: 20px;
      line-height: 1.5;
    }

    .redirect-content a {
      color: #CC0F3C;
      text-decoration: none;
    }

    .redirect-content a:hover {
      text-decoration: none;
    }

    .btn-back {
      background-color: #CC0F3C;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 0.2s;
      font-size: 14px;
    }

    .btn-back:hover {
      background-color: #5a6268;
    }

    .btn-back i {
      margin-right: 8px;
    }
  `]
})
export class ExternalLinkComponent implements OnInit {
  currentUrl = '';
  title = '';
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const routeData = this.route.snapshot.data;

    if (routeData['url']) {
      this.currentUrl = this.getExternUrl(this.authService.getCurrentClient(), routeData['url']);
      this.title = routeData['title'] || 'Externe Anwendung';

      // Kurze Verzögerung für bessere UX
      setTimeout(() => {
        this.openExternalLink();
        this.isLoading = false;
      }, 800);
    }
  }

  private getExternUrl(domain: string, path: string): string {
    if (domain == 'sug') {
      return environment.externApplicationUrls?.sug.find(app => app.path === path)?.url ?? '';
    }
    if (domain == 'ems') {
      return environment.externApplicationUrls?.ems.find(app => app.path === path)?.url ?? '';
    }
    return '';
  }

  private openExternalLink(): void {
    if (this.currentUrl) {
      window.open(this.currentUrl, '_blank');
    }
  }

  goBack(): void {
    this.router.navigate(['/home']);
  }
}
